import { authService } from './authService';
import { apiFetch } from './apiFetch';
import { ACTIVE_URL } from '../config';
import { parseErrorResponse } from '../utils/errorHandling';

const API_BASE_URL = `${ACTIVE_URL}/api/v1`;

const getHeaders = () => ({
  'Authorization': `Bearer ${authService.getAccessToken()}`,
  'Content-Type': 'application/json',
});

export const userService = {
  // --- Users ---
  async getUsers() {
    const res = await apiFetch(`${API_BASE_URL}/users/`, { headers: getHeaders() });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to fetch users');
    return res.json();
  },
  async createUser(data: Record<string, any>) {
    const res = await apiFetch(`${API_BASE_URL}/users/`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to create user');
    return res.json();
  },
  async updateUser(userId: number, data: Record<string, any>) {
    const res = await apiFetch(`${API_BASE_URL}/users/${userId}/`, {
      method: 'PATCH',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to update user');
    return res.json();
  },
  async deactivateUser(userId: number) {
    const res = await apiFetch(`${API_BASE_URL}/users/${userId}/`, {
      method: 'DELETE',
      headers: getHeaders(),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to deactivate user');
  },
  async updateUserRole(userId: string | number, roleId: string | number) {
    const res = await apiFetch(`${API_BASE_URL}/users/${userId}/`, {
      method: 'PATCH',
      headers: getHeaders(),
      body: JSON.stringify({ role_id: roleId }),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to update role');
    return res.json();
  },

  // --- Roles ---
  async getRoles() {
    const res = await apiFetch(`${API_BASE_URL}/roles/`, { headers: getHeaders() });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to fetch roles');
    return res.json();
  },

  // --- Departments ---
  async getDepartments() {
    const res = await apiFetch(`${API_BASE_URL}/departments/`, { headers: getHeaders() });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to fetch departments');
    return res.json();
  },
  async createDepartment(data: Record<string, any>) {
    const res = await apiFetch(`${API_BASE_URL}/departments/`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to create department');
    return res.json();
  },
  async updateDepartment(deptId: number, data: Record<string, any>) {
    const res = await apiFetch(`${API_BASE_URL}/departments/${deptId}/`, {
      method: 'PATCH',
      headers: getHeaders(),
      body: JSON.stringify(data),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to update department');
    return res.json();
  },
  async deactivateDepartment(deptId: number) {
    const res = await apiFetch(`${API_BASE_URL}/departments/${deptId}/`, {
      method: 'DELETE',
      headers: getHeaders(),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to deactivate department');
  },
  async triggerUserPasswordReset(userId: string | number) {
    const res = await apiFetch(`${API_BASE_URL}/auth/admin-trigger-reset/`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ user_id: userId }),
    });
    if (!res.ok) throw await parseErrorResponse(res, 'Failed to send reset link email');
    return res.json();
  }
};
